import React from 'react';
import Modal from '../elements/Modal';
import UsersPanel from '../elements/UsersPanel';

interface UsersModalProps {
  title: string;
  label?: string;
  users: string[];
  onBack?: Function;
  onClick: Function;
  onClose: Function;
}

interface UsersModalState {
}

class UsersModal extends React.Component<UsersModalProps, UsersModalState> {
  constructor(props:UsersModalProps) {
    super(props);
    this.state = {
    }
  }

  componentDidMount(): void {
  }

  render() {
    return (
      <Modal title={this.props.title} onClose={()=>this.props.onClose()} showBack={this.props.onBack != null} onBack={()=>this.props.onBack()}>
        <div className="site-page-column" style={{textAlign: 'left'}}>
          {this.props.label &&
            <div className="site-page-subtext">{this.props.label}</div>
          }
          <UsersPanel 
            height="260px"
            users={this.props.users}
            onClick={this.props.onClick}
          />
        </div>
      </Modal>
    )
  }
}

export default UsersModal;